import { defineInlineEdit } from "../../../../../components/MobileList/inlineEdit";

/**
 * views/payments/cards/form submits the whole form, and the table seeds that
 * form straight from the list row (`setDialog(params.row)`) — so the row is a
 * complete source and no detail fetch is needed. Just as well: the cards
 * endpoint has no getById.
 */
export default defineInlineEdit({
  api: "cards",
  permission: "card_edit",
  hydrate: false,
  toPayload: (source) => ({
    id: source.id,
    holder_name: source.holder_name ?? "",
    number: source.number ?? "",
    type: source.type ?? "master",
    order_issued_id: source.order_issued_id ?? "",
    issued_at: source.issued_at,
  }),
  fields: {
    holder_name: { label: "اسم حامل البطاقة", type: "text", required: true },
    number: {
      label: "رقم البطاقة",
      type: "text",
      required: true,
      inputProps: { inputMode: "numeric", dir: "ltr" },
    },
    type: {
      label: "نوع البطاقة",
      type: "options",
      required: true,
      options: [
        { value: "master", label: "Master Card" },
        { value: "visa", label: "Visa Card" },
      ],
    },
    order_issued_id: { label: "رقم الطلب", type: "text" },
    issued_at: { label: "تاريخ الإصدار", type: "date" },
  },
});
